/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Validation_Namemin1Inputs */

const he_contact_validation_namemin1 = /** @type {(inputs: Contact_Validation_Namemin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`השם חייב להכיל לפחות 2 תווים`)
};

const en_contact_validation_namemin1 = /** @type {(inputs: Contact_Validation_Namemin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name must be at least 2 characters`)
};

/**
* | output |
* | --- |
* | "Name must be at least 2 characters" |
*
* @param {Contact_Validation_Namemin1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_validation_namemin1 = /** @type {((inputs?: Contact_Validation_Namemin1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Validation_Namemin1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_validation_namemin1(inputs)
	return en_contact_validation_namemin1(inputs)
});
export { contact_validation_namemin1 as "contact_validation_nameMin" }